import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M138.098 496.183c5.73 0 11.447-2.182 15.823-6.557l223.804-223.804c8.74-8.74 8.74-22.907 0-31.646L153.921 10.372c-8.74-8.74-22.906-8.74-31.646 0s-8.74 22.906 0 31.645L330.245 250l-207.97 207.98c-8.74 8.74-8.74 22.907 0 31.647a22.3 22.3 0 0 0 15.823 6.557" }, null, -1)
  ])))
}
export default { render: render }